import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-contained-down-arrow-icon',
  templateUrl: './contained-down-arrow-icon.svg',
  styleUrls: ['./contained-down-arrow-icon.component.scss'],
})
export class ContainedDownArrowIconComponent {
  @Input() color = 'white';
}
